import { useCanAdministerAIAgents } from "~/pages/manifold-nextgen/hooks/useCanAdministerAIAgents";
import { Agent, AgentAccessLevel } from "~/services/agents";

// Toggling ENABLED/DISABLED is part of the `can_edit` capability, held by editors
// and owners. Unlike config editing (`useCanEditAgent`), a SYSTEM agent's status
// IS toggleable — its configuration is immutable but its enable/disable state is
// not — so this applies uniformly to both scopes, exactly like a CUSTOMER agent.
// The wire `access_level` is only EDITOR/OWNER when the caller holds `manage:agents`
// plus the FGA grant, so a plain `manage:agents` scope alone never confers it. An
// `admin:agents` caller can toggle any visible agent (SYSTEM included) via the FGA
// bypass, even one it holds no direct grant on.
export const useCanToggleAgentStatus = (agent: Agent | undefined): boolean => {
  const isAdmin = useCanAdministerAIAgents();
  return (
    !!agent &&
    (agent.access_level === AgentAccessLevel.OWNER ||
      agent.access_level === AgentAccessLevel.EDITOR ||
      isAdmin)
  );
};
